import { DownloadPageLayout } from '@bpm-web-app/components';
import { NewReleasesListing, NewReleasesPerCategory } from '@bpm-web-app/components/pages';
import { AnonymousUserBanner } from '@bpm-web-app/components/src/lib/shared';
import { useRouter } from 'next/router';

export default function Releases({ title }: { title: string }) {
    const { query } = useRouter();
    const { category } = query;

    return (
        <DownloadPageLayout title={title}>
            <AnonymousUserBanner addTopPadding addBottomPadding centerAlignOnMobile />
            {category ? <NewReleasesPerCategory categorySlug={`${category}`} /> : <NewReleasesListing />}
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'New Releases',
        },
    };
}
